import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "badge text-bg-warning fs-13 me-5 mt-10"
}
const _hoisted_8 = {
  key: 1,
  class: "badge text-bg-success fs-13 me-5 mt-10"
}
const _hoisted_9 = {
  key: 2,
  class: "badge text-bg-danger fs-13 me-5 mt-10"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  target: "_blank",
  href: ""
}
const _hoisted_12 = { key: 4 }
const _hoisted_13 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_14 = { class: "text-danger" }
const _hoisted_15 = { class: "text-success" }
const _hoisted_16 = { key: 6 }
const _hoisted_17 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_tamplate = _resolveComponent("tamplate")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newClientExport()))
        }, _cache[1] || (_cache[1] = [
          _createTextVNode(" Export ", -1),
          _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)
        ]))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
        _createElementVNode("input", {
          type: "text",
          class: "form-control shadow-none text-black rounded-0",
          placeholder: "Search "
        })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vue_good_table, {
        columns: _ctx.headers,
        rows: _ctx.rows
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field == 'created_at')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
            : (props.column.field === 'statut')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  (props.row.statut==0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Nouvelle Demande"))
                    : _createCommentVNode("", true),
                  (props.row.statut==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Demande traitée"))
                    : _createCommentVNode("", true),
                  (props.row.statut==2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Demande refusée"))
                    : _createCommentVNode("", true)
                ]))
              : (props.column.field === 'customer_name')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _createElementVNode("a", _hoisted_11, _toDisplayString(props.row.customer_name), 1)
                  ]))
                : (props.column.field === 'note')
                  ? (_openBlock(), _createBlock(_component_tamplate, { key: 3 }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(props.row.note), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (props.column.field === 'statut_note')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _createElementVNode("p", null, _toDisplayString(props.row.statut_note), 1)
                      ]))
                    : (props.column.field === 'new_rib')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(props.row.old_rib), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("h6", _hoisted_15, _toDisplayString(props.row.new_rib), 1)
                        ]))
                      : (props.column.field == 'action')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.fetchData
      }, null, 8, ["pagination", "onPaginate"])
    ])
  ]))
}